module.exports = __webpack_public_path__ + "img/masks-theater.5bed4af9.svg";